import React, { Component } from "react";
import { Modal, FormGroup, Row, Col, FormControl } from "react-bootstrap";
import { reduxForm, formValueSelector, Field } from "redux-form";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from 'classnames';
import updateClaimPayoutMutation from './updateClaimMutation.graphql';
import { flowRight as compose } from 'lodash';
import CurrencyConverter from "../../CurrencyConverter/CurrencyConverter";
import Loader from "../../Loader/Loader";
import messages from "../../../locale/jsonMessages";
import validate from './validate';
import { convert } from "../../../helpers/currencyConvertion";
import showToaster from "../../../helpers/toasterMessages/showToaster";
import { withMutation } from "../../../hoc/withGraphql";
import cs from '../../../components/commonStyle.css';
import s from './ClaimPayoutModal.css';
class ClaimPayoutModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loader: false
        }
    }

    submitForm = async (values) => {
        this.setState({ loader: true });
        const { closeModal, updateClaimPayout, refetch, base, rates } = this.props;
        let paymentCurrency = values.paymentMethodId == 1 ? values.paymentCurrency : values.payoutCurrency, convertedAmount;
        convertedAmount = convert(base, rates, values.claimPayout, values.currency, paymentCurrency);
        let variables = {
            reservationId: values.reservationId,
            claimPayout: parseFloat(convertedAmount.toFixed(2)),
            receiverEmail: values.receiverEmail,
            payoutId: values.payoutId,
            hostId: values.hostId,
            paymentCurrency,
            paymentMethodId: values.paymentMethodId,
            hostEmail: values.hostEmail
        }
        const { data, data: { UpdateClaimPayout } } = await updateClaimPayout({ variables })
        closeModal();
        if (UpdateClaimPayout?.status == 200) {
            showToaster({ messageId: 'payoutToHost', toasterType: 'success' })
            refetch();
        } else if (UpdateClaimPayout?.errorMessage) {
            showToaster({ messageId: 'paymentToHostFailed', toasterType: 'error' })
        } else {
            showToaster({ messageId: 'paymentToHost', toasterType: 'error' })
        }
        this.setState({ loader: false });
    }

    renderFormControlSelect = ({ input, label, meta: { touched, error }, children, className }) => {
        const { formatMessage } = this.props.intl;
        return (
            <FormGroup className={cs.noMargin}>
                <Row>
                    <Col xs={12} sm={4} md={4} lg={4}>
                        <label className='commonLabelText' >{label}</label>
                    </Col>
                    <Col xs={12} sm={8} md={8} lg={8}>
                        <div >
                            <FormControl componentClass="select" {...input} className={cx(className)} >
                                {children}
                            </FormControl>
                        </div>
                        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
                    </Col>
                </Row>
            </FormGroup>
        )
    }

    render() {
        const { show, closeModal, email, claimPayout, amountCurrency, last4Digits, paymentMethodId, handleSubmit, error, availableCurrencies, submitting } = this.props;
        const { formatMessage } = this.props.intl;
        const { loader } = this.state;

        return (
            <Modal show={show} onHide={closeModal} dialogClassName='commonModalContainer globalModalContainer' >
                <Modal.Header closeButton className='commonModalHeader'>
                    <Modal.Title className='commonModalTitle'>
                        <FormattedMessage {...messages.claimPayout} />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body bsClass='commonModalBody'>
                    <form onSubmit={handleSubmit(this.submitForm)}>
                        {error && <strong>{formatMessage(error)}</strong>}
                        <div className="oneColumnGrid">
                            <Row>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <label className='commonLabelText'><FormattedMessage {...messages.transferType} /></label>
                                </Col>
                                <Col xs={12} sm={8} md={8} lg={8}>
                                    <FormattedMessage {...messages.claimPayout} />
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <label className='commonLabelText'><FormattedMessage {...messages.transferAmount} /></label>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <CurrencyConverter
                                        amount={claimPayout}
                                        from={amountCurrency}
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <label className='commonLabelText'><FormattedMessage {...messages.receiverLabel} /></label>
                                </Col>
                                <Col xs={12} sm={8} md={8} lg={8}>
                                    {(paymentMethodId == 1) ? <span>
                                        {email}
                                    </span> : <span>
                                        ****{last4Digits}
                                    </span>
                                    }
                                </Col>
                            </Row>
                            {
                                paymentMethodId == 1 &&
                                <Field
                                    name="paymentCurrency"
                                    component={this.renderFormControlSelect}
                                    label={formatMessage(messages.currencyText)}
                                    className='commonSelectField'
                                >
                                    <option value="">{formatMessage(messages.chooseCurrency)}</option>
                                    {
                                        availableCurrencies != null && availableCurrencies.length > 0 && availableCurrencies.map((currency, index) => {
                                            if (currency.isEnable === true && currency.isPayment) {
                                                return <option key={index} value={currency.symbol}>{currency.symbol}</option>
                                            }
                                        })
                                    }
                                </Field>
                            }
                            <Loader
                                type={"button"} buttonType={"submit"}
                                label={formatMessage(messages.confirmLabel)}
                                show={loader} disabled={loader}
                                className={cx(cs.btnPrimary, s.fullWidth, 'loaderButtonFlex')} />
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        )
    }
}



ClaimPayoutModal = reduxForm({
    form: 'ClaimPayoutForm',
    validate
})(ClaimPayoutModal);

const selector = formValueSelector('ClaimPayoutForm')

const mapState = (state) => ({
    availableCurrencies: state.currency.availableCurrencies,
    rates: state.currency.rates,
    base: state.currency.base,
    reservationId: selector(state, 'reservationId'),
    email: selector(state, 'receiverEmail'),
    payoutId: selector(state, 'payoutId'),
    claimPayout: selector(state, 'claimPayout'),
    amountCurrency: selector(state, 'currency'),
    paymentMethodId: selector(state, 'paymentMethodId'),
    last4Digits: selector(state, 'last4Digits'),
});

const mapDispatch = {

}

export default compose(
    injectIntl,
    withStyles(cs, s),
    connect(mapState, mapDispatch),
    withMutation(updateClaimPayoutMutation, { name: 'updateClaimPayout' }),
)(ClaimPayoutModal);
